export default [
  {
    key: 'name',
    label: 'Name',
    sortable: true,
    show: true,
    class: 'text-center align-middle text-capitalize',
  },
  {
    key: 'segment_name',
    label: 'Segment Name',
    sortable: true,
    show: true,
    class: 'text-center align-middle text-capitalize',
  },
  {
    key: 'description',
    label: 'Description',
    sortable: true,
    show: true,
    class: 'text-center align-middle text-capitalize',
  },
  {
    key: 'distribution_id',
    label: 'Distribution ID',
    sortable: true,
    show: true,
    class: 'text-center align-middle text-capitalize',
  },
  {
    key: 'segment_id',
    label: 'Segment ID',
    sortable: true,
    show: true,
    class: 'text-center align-middle text-capitalize',
  },
  {
    key: 'segment_value',
    label: 'Segment Value',
    sortable: true,
    show: true,
    class: 'text-center align-middle text-capitalize',
  },
  {
    key: 'source',
    label: 'Source',
    sortable: true,
    show: true,
    class: 'text-center align-middle text-capitalize',
  },
  {
    key: 'provider',
    label: 'Provider',
    sortable: true,
    show: true,
    class: 'text-center align-middle text-capitalize',
  },
  {
    key: 'restrictions',
    label: 'Restrictions',
    sortable: true,
    show: false,
    class: 'text-center align-middle text-capitalize',
  },
  {
    key: 'permitted_advertisers',
    label: 'Permitted Advertisers',
    sortable: true,
    show: false,
    class: 'text-center align-middle text-capitalize',
  },
  {
    key: 'cost',
    label: 'Cost',
    sortable: true,
    show: true,
    type: 'currency',
    class: 'text-center align-middle text-capitalize',
  },
  {
    key: 'custom',
    label: 'Custom',
    sortable: true,
    show: false,
    class: 'text-center align-middle text-capitalize',
  },
  {
    key: 'third_party',
    label: 'Third Party',
    sortable: true,
    show: false,
    class: 'text-center align-middle text-capitalize',
  },
  {
    key: 'status',
    label: 'Status',
    sortable: true,
    show: true,
    class: 'text-center align-middle text-capitalize',
  },
  {
    key: 'action',
    label: '',
    sortable: false,
    show: true,
    type: 'action_list',
    tdClass: 'actions',
    thStyle: { width: '160px' },
    class: 'text-center align-middle text-capitalize',
    thClass: 'align-middle text-center',
    actions: [
      {
        icon: 'pencil',
        title: 'Edit',
        event: 'edit',
        top_level: true,
      },
    ],
  },
]
